<template>
    <div class="offers-page">
        <common-content-spacer height="tiny">
            <offer-filter :filter="filterApplied" :showMapToggle="!showToggle" @togglemap="toggleMap()"></offer-filter>
            <offer-results
                ref="offerResults"
                :filter="filterApplied"
                :showMap="showMap"
                :showMapToggle="showToggle"
                :userLocation="userLocation"
            ></offer-results>
        </common-content-spacer>
    </div>
</template>

<script>
    import OfferResults from 'components/page-elements/offer/OfferResults'
    import OfferFilter from 'components/page-elements/offer/OfferFilter'
    import WindowResizeMixin from 'mixins/WindowResizeMixin'
    import LocationService from 'services/LocationService'

    export default {
        mixins: [WindowResizeMixin],

        components: { OfferResults, OfferFilter },
        data: () => ({
            filterApplied: {},
            allowedKeys: [
                'countryId',
                'cityId',
                'currency',
                'fromPrice',
                'includeDescription',
                'orderBy',
                'serviceGroupId',
                'serviceId',
                'toPrice',
                'wayDefinition',
                'filter',
            ],
            showMap: true,
            userLocation: null,
        }),
        computed: {
            showToggle() {
                return this.isTabletSmall
            },
        },
        methods: {
            toggleMap() {
                this.showMap = !this.showMap
            },
            async fetchUserLocationAndApplyFilter() {
                const currentLocation = LocationService.getCachedLocation()
                if (!currentLocation) {
                    this.setFilterApplied()
                }
                try {
                    const position = await LocationService.getCurrentPosition()
                    this.userLocation = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    }
                } catch (error) {
                    this.userLocation = null
                } finally {
                    this.setFilterApplied()
                }
            },
            setFilterApplied() {
                const filterApplied = Object.keys(this.$route.query).reduce((acc, key) => {
                    if (this.allowedKeys.includes(key)) {
                        acc[key] = this.$route.query[key]
                    }
                    return acc
                }, {})

                if (filterApplied.serviceGroupId) {
                    filterApplied.serviceGroupId = Number(filterApplied.serviceGroupId)
                }
                if (filterApplied.includeDescription) {
                    filterApplied.includeDescription = filterApplied.includeDescription === 'true'
                }
                this.filterApplied = filterApplied
            },
        },
        watch: {
            '$route.query'() {
                this.setFilterApplied()
            },
        },
        mounted() {
            this.fetchUserLocationAndApplyFilter()
        },
    }
</script>

<style lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/mixins';
    .offers-page {
        position: relative;
        height: auto;
        .offer-filter {
            width: 100%;
            position: sticky;
            top: 55px;
            left: 18px;
            width: calc(100% - 20px);
            z-index: 2;
        }
    }
</style>
